import { render, staticRenderFns } from "./AssetReview.vue?vue&type=template&id=752b7094"
import script from "./AssetReview.vue?vue&type=script&lang=js"
export * from "./AssetReview.vue?vue&type=script&lang=js"
import style0 from "./AssetReview.vue?vue&type=style&index=0&id=752b7094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports